import { lazyLoad } from 'components/ui/LazyLoad'
import { PAYMENT_REDIRECT_PAGE_PATH } from 'components/ui/PaymentRedirect'
import PaymentRedirect from 'views/PaymentRedirect'
import IframeRedirect from 'views/IframeRedirect'

export const appRoutes = {
  main: {
    path: '/',
    component: lazyLoad(() => import('views/Main')),
    meta: {
      title: 'GameSkinX - Premium CS 2 Skins for Ultimate Gaming Experience',
      description:
        'Discover GameSkinX, your trusted store for CS 2 skins. Safe, manual delivery, competitive prices, and fast service for all gamers.',
    },
  },
  faq: {
    path: '/frequently-asked-questions',
    component: lazyLoad(() => import('views/Faq')),
    meta: {
      title: 'FAQ | GameSkinX ',
      description:
        'Find answers to common questions about purchasing CS 2 skins from GameSkinX, including delivery times, payment methods, and customer safety.',
    },
  },
  contacts: {
    path: '/contacts',
    component: lazyLoad(() => import('views/Contacts')),
    meta: {
      title: "Contact GameSkinX – We're Here to Help",
      description:
        'Have questions or need assistance? Get in touch with the GameSkinX team for help with your orders, account inquiries, and more.',
    },
  },
  about: {
    path: '/about',
    component: lazyLoad(() => import('views/About')),
    meta: {
      title: 'About GameSkinX – Trusted Store for CS 2 Skins',
      description:
        'Learn more about GameSkinX, your trusted source for buying CS 2 skins. We offer secure manual transactions and competitive prices to enhance your gaming experience.',
    },
  },
  blog: {
    path: '/blog',
    component: lazyLoad(() => import('views/Blog')),
    meta: {
      title: 'Blog - GameSkinX',
      description: 'Blog - GameSkinX',
    },
  },
  blogDetail: {
    path: '/blog/:id(1|2|3|4|5|6|7)',
    component: lazyLoad(() => import('views/BlogDetail')),
    meta: {
      title: 'Blog - GameSkinX',
      description: 'Blog - GameSkinX',
    },
  },
  careers: {
    path: '/careers',
    component: lazyLoad(() => import('views/Careers')),
    meta: {
      title: 'Careers - GameSkinX',
      description:
        'Want to join us on our mission in the digital content world? Explore current opportunities and join the GameSkinX team, from anywhere.',
    },
  },
  careersDetail: {
    path: '/careers/:id(designer|frontend|backend|seo)',
    component: lazyLoad(() => import('views/Careers/CareersDetail')),
    meta: {
      title: 'Careers - GameSkinX',
      description:
        'Want to join us on our mission in the digital content world? Explore current opportunities and join the GameSkinX team, from anywhere.',
    },
  },
  contributors: {
    path: '/content-contributors',
    component: lazyLoad(() => import('views/Contributors')),
    meta: {
      title: 'Content Contributors - GameSkinX',
      description:
        'Become part of the creative GameSkinX community where top brands, global media houses, and leading ad agencies can see your content.',
    },
  },
  catalog: {
    path: '/shop',
    component: lazyLoad(() => import('views/Catalog')),
  },
  catalogDetailPhoto: {
    path: '/shop/:id',
    component: lazyLoad(() => import('views/DetailPhoto')),
  },
  buy: {
    path: '/buy',
    component: lazyLoad(() => import('views/Buy')),
  },
  pricing: {
    path: '/profile/buy',
    component: lazyLoad(() => import('views/profile/BuyCredits/BuyMain')),
  },
  buyProceed: {
    path: '/buy/:uuid',
    exact: true,
    component: lazyLoad(() => import('views/BuyProceed')),
  },
  buyBillingInfo: {
    path: '/buy/billing-info',
    exact: true,
    component: lazyLoad(() => import('views/BuyBillingInfo')),
  },
  paymentRedirect: {
    path: PAYMENT_REDIRECT_PAGE_PATH,
    exact: true,
    component: PaymentRedirect,
  },
  b2cRedirect: {
    path: '/b-back',
    exact: true,
    component: IframeRedirect,
  },
} as const
